import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogBody, DialogFooter } from "../Dialog";
import Button from "../Buttons/Button";
import SubscriberAdminsManager from "../SubscriberAdminsManager";

/**
 * Dialog wrapper around SubscriberAdminsManager. Kept separate from forms with a Save button because
 * admin changes are applied immediately (used from the edit subscriber dialog and the company settings page).
 */
export default function SubscriberAdminsDialog({ open, onClose, subscriberUniqueId, currentUserId, onAdminsChanged }) {
  const { t } = useTranslation();

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="sm">
      <DialogHeader>
        <DialogTitle>{t("subscriberAdmins.title")}</DialogTitle>
        <DialogDescription>
          {t("subscriberAdmins.description")} {t("subscriberAdmins.savedImmediately")}
        </DialogDescription>
      </DialogHeader>
      <DialogBody>
        {open && <SubscriberAdminsManager subscriberUniqueId={subscriberUniqueId} currentUserId={currentUserId} onAdminsChanged={onAdminsChanged} />}
      </DialogBody>
      <DialogFooter>
        <Button variant="light" onClick={onClose}>
          {t("common.close")}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
